<template>
  <popup-container>
    <template slot="header">
      {{ $l.userCountrySelect }}
    </template>

    <div class="popup-option"
      v-for="(option, index) in options"
      :key="index"
      @click="select(option)">
      {{ option.get(locale) }}
    </div>
  </popup-container>
</template>

<script>
import PopupContainer from '@/components/Popup/Container'
import MixinLocale from '@/components/MixinLocale'
import MixinIsSettingsUser from '@/components/Settings/MixinIsSettingsUser'

export default {
  mixins: [
    MixinLocale,
    MixinIsSettingsUser
  ],

  components: {
    PopupContainer
  },

  created: function () {
    this.$store.dispatch('country/retrieveCountries')
  },

  computed: {
    options: function () {
      return this.$store.getters['country/countries']
    }
  },

  methods: {
    select: function (option) {
      this.$store.commit('user/setCountry', option)
      if (this.isSettingsUser) {
        this.$store.dispatch('user/saveCountry', option)
      }
      this.$store.dispatch('popup/hide', null)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
